// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8320640","453":"55144461","455":"bbdda94f","977":"cd238f1a"}[chunkId] + ".chunk.js";
};